import {
  DataProvider,
  ICreatePaymentOrderRequestModel,
  IErrorModel,
  IPaymentOrderModel,
  useMutation,
  UseMutationOptions,
} from "@nf/common";

type CreatePaymentOrderOptions = UseMutationOptions<
  IPaymentOrderModel,
  IErrorModel,
  ICreatePaymentOrderRequestModel
>;

export const useCreatePaymentOrder = (options?: CreatePaymentOrderOptions) => {
  return useMutation<
    IPaymentOrderModel,
    IErrorModel,
    ICreatePaymentOrderRequestModel
  >((data) => DataProvider.createPaymentOrder(data), options);
};
